// Define initial state
const initialState = {

    loading: false,
    error: null,
    message: null,
    data: [],
    visible: false
};

// Define contact submission reducer
const paymentRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        

        case 'PAYMENT_REQUEST_LIST_SUCCESS':
            return {
                ...state,
                loading: false,
                error: false,
                data: action?.payload?.data,
                message: action?.payload?.message
            };

        case 'ACCOUNT_REQUEST_LIST_FAILURE':
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload,
                visible: true,
                data: []
            }

        default:
            return state;
    }
};

export default paymentRequestReducer;
